import { memo, forwardRef, type FocusEventHandler, type MouseEventHandler } from 'react';
import classNames from 'classnames';
// import Types
import type { HolderProps } from 'types';
// import UI Components
import { Holder } from '@geneui/components';
// import Styles
import 'assets/scss/holderWrapper.scss';

interface Props extends Omit<HolderProps, 'disabled'> {
    isDisabled?: boolean;
    containerClassName?: string;
    children?: React.ReactNode;
    onFocus?: FocusEventHandler<HTMLDivElement>;
    onMouseDown?: MouseEventHandler<HTMLDivElement>;
}

const HolderWrapper = forwardRef<HTMLDivElement, Props>(
    ({ children, isDisabled, containerClassName, onFocus, onMouseDown, ...rest }, ref) => {
        return (
            <div
                ref={ref}
                className={classNames('crm-holder-wrapper', containerClassName)}
                onFocus={onFocus}
                onMouseDown={onMouseDown}
            >
                <Holder disabled={isDisabled} {...rest}>
                    {children}
                </Holder>
            </div>
        );
    },
);

HolderWrapper.displayName = 'HolderWrapper';

export default memo(HolderWrapper);
